// Caturnusa Sejahtera Finance / Corporate Paylater
export const CSF_URL = "https://www.paylater.co.id/product/";

// Arrange a meeting typeform URL
export const MEETING_URL = "https://form.typeform.com/to/Qbty6fUj";
